import { Clip } from '../types/clip-types';
import { getClipVersion } from './clipUtils';

export const prepareClipForFinalSave = (clip: Clip): { finalClip: Clip; version: number } => {
  let finalClip = structuredClone(clip);
  const clipLayout = finalClip.asset_metadata.layout;

  const useRemotionCaptions = clipLayout !== 'AUDIOGRAM';

  const version = getClipVersion();

  finalClip = {
    ...finalClip,
    version
  };

  // START - CR-4289 - captions-undo-fix
  // This code is same as in clip.ts. That is required for history handling. This is required for clip handling
  // Temp code. Will be cleaned after removal of shared api
  const showCaptions = !!finalClip.asset_metadata.subtitle;
  if (
    finalClip.asset_metadata.caption_positions === undefined &&
    finalClip.asset_metadata.caption_styles?.placement === undefined &&
    showCaptions &&
    useRemotionCaptions
  ) {
    finalClip = {
      ...finalClip,
      asset_metadata: {
        ...finalClip.asset_metadata,
        caption_positions: {
          x: '2.5%',
          y: '82%',
          width: '95%',
          height: '18%'
        } as any
      }
    };
  }

  finalClip.asset_metadata.config = null;

  return { finalClip, version };
};
